import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import Drawer from '@material-ui/core/Drawer'
import SortableFieldPicker from 'components/sortableFieldPicker'
import {t} from "helpers/language"
import {getDefaultVisibleColumns} from "helpers/pivotTable"

const DRAWER_WIDTH = 350

class FieldPicker extends Component {
  state = {
    options: [],
  }

  UNSAFE_componentWillMount = () => {
    if (this.props.visible) {
      this.setState({options: this.getOptions()})
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (!this.props.visible && nextProps.visible) {
      this.setState({options: this.getOptions()})
    }
  }

  getOptions = (overrideVisibleColumns) => {
    const {allColumns, visibleColumns} = this.props
    const currentVisibleColumns = !isNil(overrideVisibleColumns) ? overrideVisibleColumns : visibleColumns

    // Column picker: visible columns in specified order, all other columns in alphabetical order
    let invisibleColumns = Object.keys(allColumns).map(k => allColumns[k])
    invisibleColumns = invisibleColumns.filter(c => currentVisibleColumns.indexOf(c.key) === -1)

    let index = 0
    const visibleOptions = currentVisibleColumns.map(k => {
      const c = allColumns[k]
      return {
        key: c.key,
        index: index++,
        label: this.getLabel(c),
        active: true,
        visible: c.selectable !== false,
      }
    }).filter(c => c.visible)

    let invisibleOptions = invisibleColumns.map(c => ({
      key: c.key,
      index: index++,
      label: this.getLabel(c),
      active: false,
      visible: c.selectable !== false,
    })).filter(c => c.visible)

    invisibleOptions = invisibleOptions.sort(this.sortOptions)

    return [
      ...visibleOptions,
      ...invisibleOptions,
    ]
  }

  getLabel = (col) => {
    let ret = col.label
    if (isNil(ret) || ret.length === 0) ret = col.alias
    if (isNil(ret) || ret.length === 0) ret = col.key
    return ret
  }

  sortOptions = (a, b) => {
    if (a.label > b.label) return 1
    if (a.label < b.label) return -1
    return 0
  }

  selectColumn = (column, selected) => {
    const {onVisibleColumnsChanged, visibleColumns} = this.props
    const {options} = this.state

    let newCols = [...visibleColumns]
    const c = options.find(f => f.key === column.key)
    const index = c ? c.index : newCols.length

    if (selected) {
      newCols.splice(index, 0, column.key)
    } else {
      newCols = newCols.filter(c => c !== column.key)
    }

    if (newCols.length > 0) {
      onVisibleColumnsChanged(newCols)
      this.setState({
        options: options.map(f => ({
          ...f,
          active: f.key === column.key ? selected : f.active,
        })),
      })
    }
  }

  moveColumn = (column, fromIndex, toIndex) => {
    const {onVisibleColumnsChanged} = this.props
    const {options} = this.state

    const newOptions = this.shiftColumn(options, fromIndex, toIndex)
    this.setState({options: newOptions})

    const newCols = newOptions.filter(c => c.active).map(c => c.key)
    onVisibleColumnsChanged(newCols)
  }

  shiftColumn = (columns, fromIndex, toIndex) => {
    const ret = [...columns]
    ret.splice(fromIndex, 1)
    ret.splice(toIndex, 0, columns[fromIndex])
    ret.forEach((c, index) => {
      c.index = index
    })
    return ret
  }

  onResetColumnsToDefault = () => {
    const {allColumns, onVisibleColumnsChanged} = this.props

    const defaultVisibleColumns = getDefaultVisibleColumns(allColumns)
    this.setState({options: this.getOptions(defaultVisibleColumns)})
    onVisibleColumnsChanged(defaultVisibleColumns)
  }

  getFieldPicker = () => {
    const {visible} = this.props
    const {options} = this.state

    if (!visible) {
      return null
    }

    return (
      <SortableFieldPicker
        fields={options}
        onMove={this.moveColumn}
        onResetColumnsToDefault={this.onResetColumnsToDefault}
        onSelect={this.selectColumn}
        searchable={true}
        sortable={true}
        title={t("Choose Fields")}
      />
    )
  }

  render() {
    const {onClose, visible} = this.props

    return (
      <Drawer
        disablePortal={true}
        open={visible}
        onClose={onClose}
        PaperProps={{
          style: {width: DRAWER_WIDTH, overflowX: 'hidden'},
        }}
      >
        {this.getFieldPicker()}
      </Drawer>
    )
  }
}

FieldPicker.propTypes = {
  allColumns: propTypes.object.isRequired,
  onClose: propTypes.func.isRequired,
  onVisibleColumnsChanged: propTypes.func.isRequired,
  visible: propTypes.bool.isRequired,
  visibleColumns: propTypes.arrayOf(propTypes.string).isRequired,
}

export default FieldPicker
